// extracted by mini-css-extract-plugin
export default {"note-form-content":"note-form-content---BMc_F"};